module.exports = __webpack_public_path__ + "media/Droid Serif-400.svg";


//////////////////
// WEBPACK FOOTER
// ../assets/media/editor/font/Droid Serif-400.svg
// module id = 3467
// module chunks = 0